/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_Select_FileInputs */



/**
* | output |
* | --- |
* | "Please select a file" |
*
* @param {Please_Select_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const please_select_file = /** @type {((inputs?: Please_Select_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_Select_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez sélectionner un fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Datei aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите файл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor seleccione un archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um arquivo.")
	return /** @type {LocalizedString} */ ("Please select a file")
});